import { createReducer, on } from '@ngrx/store';
import { Feed } from '../domain/feed';
import { DesignatedContentGroup } from './components/designated-content-group-dialog/designated-content-group-dialog.view-model';
import * as Actions from './content-group-list-screen.actions';

export const featureKey = 'cxbContentGroupList';

export interface FeatureState {
  feeds: Feed[];
  designatedContentGroups: DesignatedContentGroup[];
  loading: boolean;
}

export interface AppState {
  [featureKey]: FeatureState;
}

export const initialState: FeatureState = {
  feeds: [],
  designatedContentGroups: [],
  loading: false,
};

export const reducer = createReducer(
  initialState,
  on(Actions.createContentGroup, (state): FeatureState => ({ ...state, loading: true })),
  on(Actions.createContentGroupSuccess, (state): FeatureState => ({ ...state, loading: false })),
  on(Actions.createContentGroupFail, (state): FeatureState => ({ ...state, loading: false })),

  on(Actions.loadScreen, (state): FeatureState => ({ ...state, feeds: [], designatedContentGroups: [], loading: true })),
  on(
    Actions.loadScreenSuccess,
    (state, action): FeatureState => ({ ...state, loading: false, feeds: action.feeds, designatedContentGroups: action.contentGroups })
  ),
  on(Actions.loadScreenFail, (state): FeatureState => ({ ...state, loading: false })),

  on(Actions.updateDesignatedContentGroups, (state): FeatureState => ({ ...state, loading: true })),
  on(
    Actions.updateDesignatedContentGroupsSuccess,
    (state, action): FeatureState => ({
      ...state,
      loading: false,
      designatedContentGroups: action.contentGroups,
    })
  ),
  on(Actions.updateDesignatedContentGroupsFail, (state): FeatureState => ({ ...state, loading: false }))
);
